import createRepository from '../../lib/basicRepository';
import { restApi } from '../../services/api';

const PATH = '/users/first-access';

export const firstAccessRepository = () =>
  createRepository({
    path: PATH,
    restApi,
  });
